var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{staticClass:"c-icon",class:[`ci-${_vm.icon}`],style:({ fontSize: `${_vm.size}px`, color: _vm.color })})
}
var staticRenderFns = []

export { render, staticRenderFns }